import React from 'react'
import { browserHistory, Router } from 'react-router'
import { Provider } from 'react-redux'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import Setting from '../containers/SettingContainer'
// import ScrollUpButton from 'react-scroll-up-button'

class App extends React.Component {
  static propTypes = {
    store: PropTypes.object.isRequired,
    routes: PropTypes.object.isRequired,
  }

  shouldComponentUpdate () {
    return false
  }

  render () {
    return (
      <Provider store={this.props.store}>
        <div style={{ height: '100%' }}>
          <Helmet>
            <title>{Setting.companyNameShort + ', ' + Setting.companyName}</title>
            <meta charSet='UTF-8' />
            <meta name='viewport' content='width=device-width, initial-scale=1' />
            <meta name='keywords' content={Setting.companyNameShort + ', ' + Setting.companyName} />
            <meta name='description' content={Setting.companyDescription} />
            <meta name='author' content={Setting.web} />
            <meta name='geo.region' content='VN-Hồ Chí Minh' />
            <meta name='DC.title' content={'Địa chỉ C&ocirc;ng Ty ' + Setting.companyNameShort} />
            <meta name='geo.placename' content={Setting.companyAddress} />
            <meta name='geo.position' content={Setting.companylat + ';' + Setting.companylng} />
            <meta name='ICBM' content={Setting.companylat + ', ' + Setting.companylng} />
            <meta httpEquiv='Cache-control' content='public' />
            <meta property='og:site_name' content={Setting.companyNameShort} />
            <meta property='og:title' content={Setting.companyNameShort + ', ' + Setting.companyName} />
            <meta property='og:image' content={Setting.logo} />
            <meta property='og:description' content={Setting.companyDescription} />
            <link rel='alternate' hrefLang='vi' href='alternateURL' />
            <link rel='apple-touch-icon' sizes='144x144' href='images/favicons/apple-touch-icon.png' />
            <link rel='icon' type='image/png' href='images/favicons/favicon-32x32.png' sizes='32x32' />
            <link rel='icon' type='image/png' href='images/favicons/favicon-16x16.png' sizes='16x16' />
            <link rel='manifest' href='images/favicons/manifest.json' />
            <link rel='mask-icon' href='images/favicons/safari-pinned-tab.svg' />
            <link rel='shortcut icon' href='/favicon.ico' type='image/x-icon' />
            <link rel='icon' href='/favicon.ico' type='image/x-icon' />
            <meta name='theme-color' content='#ffffff' />
            <link href='/lib/styles.css' rel='stylesheet' type='text/css' />
            <link href='/lib/bootstrap.css' rel='stylesheet' type='text/css' />
            <link href='/lib/bootstrap-select.css' rel='stylesheet' type='text/css' />
            <link href='/lib/font-awesome.css' rel='stylesheet' type='text/css' />
            <link href='/lib/owl.carousel.css' rel='stylesheet' type='text/css' />
            <link href='/lib/jquery-ui.css' rel='stylesheet' type='text/css' />
            <link href='/lib/slick.css' rel='stylesheet' type='text/css' />
            <link href='/lib/slick-theme.css' rel='stylesheet' type='text/css' />
            <link href='/lib/prettyPhoto.css' rel='stylesheet' type='text/css' />
            <script type='text/javascript' src='
              https://maps.googleapis.com/maps/api/js?key=AIzaSyDyqZrJ5V54ZDrD24RbEUO0JXeJ1JsNEr0&amp;callback=initMap
              ' />
            <script type='application/ld+json'>
              {`
              {
                '@context' : [
                  'http://schema.org',
                    { '@language': 'vi-vn' }
                ],
                '@type': 'Library',
                'telephone': '+8402835901595',
                'priceRange': '0.1-10000',
                'image': '` + Setting.web + `/assets/img/logo1-default.png',
                'address':  {
                  '@id': '_:school_edu_library_1',
                  '@type': 'PostalAddress',
                  'streetAddress': '` + Setting.companyAddress + `',
                  'addressLocality': '` + Setting.addressLocality + `',
                  'addressRegion': '` + Setting.addressRegion + `',
                  'postalCode': '` + Setting.postalCode + `',
                  'addressCountry': '` + Setting.addressCountry + `'
                },
                'email':  'mailto:` + Setting.companyEmail + `',
                'location': { '@id': '_:school_edu_library_1' },
                'name':  '` + Setting.companyName + `',
                'parentOrganization': 'https://laurentian.concat.ca/eg/opac/library/LUSYS',
                'openingHoursSpecification': [
                  {
                    '@type': 'OpeningHoursSpecification',
                    'closes':  '17:00:00',
                    'dayOfWeek': 'http://schema.org/Sunday',
                    'opens':  '08:00:00'
                  },
                  {
                    '@type': 'OpeningHoursSpecification',
                    'closes': '17:00:00',
                    'dayOfWeek': 'http://schema.org/Saturday',
                    'opens': '08:00:00'
                  },
                  {
                    '@type': 'OpeningHoursSpecification',
                    'closes':  '17:00:00',
                    'dayOfWeek': 'http://schema.org/Thursday',
                    'opens': '08:00:00'
                  },
                  {
                    '@type': 'OpeningHoursSpecification',
                    'closes': '17:00:00',
                    'dayOfWeek': 'http://schema.org/Tuesday',
                    'opens': '08:00:00'
                  },
                  {
                    '@type': 'OpeningHoursSpecification',
                    'closes': '17:00:00',
                    'dayOfWeek':  'http://schema.org/Friday',
                    'opens': '08:00:00'
                  },
                  {
                    '@type': 'OpeningHoursSpecification',
                    'closes': '17:00:00',
                    'dayOfWeek': 'http://schema.org/Monday',
                    'opens': '08:00:00'
                  },
                  {
                    '@type': 'OpeningHoursSpecification',
                    'closes': '17:00:00',
                    'dayOfWeek':  'http://schema.org/Wednesday',
                    'opens': '08:00:00'
                  }
                ]
              }
              `}
            </script>
            <script type='application/ld+json'>
              {`
              {
                '@context' : 'http://schema.org',
                '@type': 'WebSite',
                'potentialAction': {
                  '@type': 'SearchAction',
                  'target': '` + Setting.web + `/tim-kiem/{search_term_string}',
                  'query-input': 'required name=search_term_string'
                },
                'image': [
                  '` + Setting.web + `/assets/img/logo1-default.png'
                ],
                '@id': '` + Setting.web + `',
                'name': '` + Setting.companyName + `',
                'url': '` + Setting.web + `'
              }
              `}
            </script>
          </Helmet>
          <Router history={browserHistory} children={this.props.routes} />
          {/*<ScrollUpButton />*/}
        </div>
      </Provider>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/components/App.js